<template>
  <div v-if="networks && networks.length > 0">
    <h4 v-if="title" class="mb-3">
      <strong>{{ title }}</strong>
    </h4>
    <slot name="heading"></slot>
    <slot v-if="!$auth.auth" name="not-logged-in"></slot>
    <p v-if="networks && networks.length === 0">
      <slot name="empty"></slot>
    </p>
    <div v-else class="row no-gutters">
      <div
        v-for="network in networks"
        :key="network.id"
        class="col-md-6 col-lg-4 col-xl-3 col-sm-12 d-flex align-items-stretch"
      >
        <NetworkCard
          :network="network"
          :hide-footer="hideFooter"
          :selectable="selectable"
          :selected="selectedSlugs.includes(network.slug)"
          :just-requested="justRequestedSlugs.includes(network.slug)"
          @toggle="$emit('toggle', $event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import NetworkCard from '@/components/commons/Networks/NetworkCard.vue';

export default {
  components: {
    NetworkCard,
  },
  props: {
    networks: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selectedSlugs: {
      type: Array,
      default: () => [],
    },
    justRequestedSlugs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
